import { platNet, eimNet } from '../instance/nets'

const API_USERINFO = '/api/user'
const GETUSERS = '/api/sysUser/queryByCondition'

/**
 * 获取当前登录用户信息
 */
export function fetchUserInfo(params) {
    return platNet.post(API_USERINFO, params)
}
/**
 * 搜索人员
 */
export function getUsers(params) {
    return eimNet.post(GETUSERS, params)
}



